(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2782],{

/***/ 52782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content042": function() { return /* binding */ Content042; },
  "default": function() { return /* binding */ Content042_Content042; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/components/widgets/content/Content042/Content042.module.scss
var Content042_module = __webpack_require__(37204);
var Content042_module_default = /*#__PURE__*/__webpack_require__.n(Content042_module);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/components/widgets/content/Content042/SingleImage/SingleImage.module.scss
var SingleImage_module = __webpack_require__(46018);
var SingleImage_module_default = /*#__PURE__*/__webpack_require__.n(SingleImage_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content042/SingleImage/SingleImage.jsx




var SingleImage = function(param) {
    var images = param.images;
    var _images = (0,_sliced_to_array/* default */.Z)(images, 1), singleImage = _images[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
        image: singleImage,
        className: (SingleImage_module_default()).image
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content042/SingleImage/index.js


// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./src/components/widgets/content/Content042/SliderImages/SliderImages.module.scss
var SliderImages_module = __webpack_require__(76557);
var SliderImages_module_default = /*#__PURE__*/__webpack_require__.n(SliderImages_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content042/SliderImages/SliderImages.jsx







var SliderImages = function(param) {
    var images = param.images;
    var prevRef = (0,react.useRef)(null);
    var nextRef = (0,react.useRef)(null);
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SliderImages_module_default()).slider,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SwiperLayout */.OJ, {
                prevRef: prevRef,
                nextRef: nextRef,
                watchOverflow: false,
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: true,
                paginationWrapper: (SliderImages_module_default()).pagination,
                children: images.map(function(image) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: (SliderImages_module_default()).slide,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                            image: image,
                            className: (SliderImages_module_default()).image
                        })
                    }, image.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SliderImages_module_default())["navigation-wrapper"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (SliderImages_module_default())["slider-navigation"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: prevRef,
                                className: classnames_default()((SliderImages_module_default()).navigation, (SliderImages_module_default())["navigation-prev"]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    className: (SliderImages_module_default()).icon,
                                    name: "arrow_slider_prev"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: nextRef,
                                className: classnames_default()((SliderImages_module_default()).navigation, (SliderImages_module_default())["navigation-next"]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    className: (SliderImages_module_default()).icon,
                                    name: "arrow_slider_next"
                                })
                            })
                        ]
                    }),
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SliderImages_module_default()).pagination
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content042/SliderImages/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content042/Item/Item.module.scss
var Item_module = __webpack_require__(59890);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content042/Item/Item.jsx






var Item = function(param) {
    var item = param.item;
    var Block = (item.images || []).length === 1 ? SingleImage : SliderImages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Item_module_default()).item,
        children: [
            item.images && /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                images: item.images,
                className: (Item_module_default()).image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Item_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                        className: (Item_module_default()).title,
                        children: item.title
                    }),
                    item.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading4 */.k8, {
                        className: (Item_module_default()).subtitle,
                        color: "brand",
                        children: item.subtitle
                    }),
                    item.labels && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (Item_module_default()).labels,
                        color: "blue",
                        uppercase: true,
                        children: item.labels
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                        value: item.description,
                        className: (Item_module_default()).description
                    }),
                    (item === null || item === void 0 ? void 0 : item.link) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* PageLink */.H_, {
                        link: item === null || item === void 0 ? void 0 : item.link,
                        className: (Item_module_default()).link,
                        target: item === null || item === void 0 ? void 0 : item.target,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                className: (Item_module_default()).button,
                                color: "brand",
                                appearance: "bigger",
                                children: item.buttonText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                className: (Item_module_default()).icon,
                                name: "arrow_right"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content042/Item/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content042/Content042.jsx




var Content042 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var items = (ref1 = payload === null || payload === void 0 ? void 0 : payload.items) !== null && ref1 !== void 0 ? ref1 : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content042_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                    className: (Content042_module_default()).title,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content042_module_default()).content,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Content042_module_default()).items,
                        children: items.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                item: item
                            }, item.id);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Content042_Content042 = (Content042);


/***/ }),

/***/ 37204:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content042_wrapper__G48X4","title":"Content042_title__ejSuG","items":"Content042_items___t_hn","content":"Content042_content__0zbXo"};

/***/ }),

/***/ 59890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"Item_content__5foPY","item":"Item_item__SQNIp","title":"Item_title__rcloW","labels":"Item_labels__kpnh_","subtitle":"Item_subtitle__6Xxrs","description":"Item_description__pjXnA","icon":"Item_icon__Vxcbq","button":"Item_button__GdLO2","link":"Item_link__VR_xV"};

/***/ }),

/***/ 46018:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"SingleImage_image__kb9hc"};

/***/ }),

/***/ 76557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"SliderImages_slider__7rWU3","slide":"SliderImages_slide___rH61","image":"SliderImages_image__dtXVI","navigation-wrapper":"SliderImages_navigation-wrapper___eNUB","pagination":"SliderImages_pagination__w1sea","pagination-current":"SliderImages_pagination-current__nyipC","slider-navigation":"SliderImages_slider-navigation__cdCAh","navigation":"SliderImages_navigation__kvcfP","navigation-prev":"SliderImages_navigation-prev__1mnXt","navigation-next":"SliderImages_navigation-next__Dfpli"};

/***/ })

}]);